import React from "react";
import { Calendar } from "../components/ui/calendar";
import { toast } from "sonner";
import api from "../lib/api";

const TIME_SLOTS = ["09:00-11:00", "11:00-13:00", "13:00-15:00", "15:00-17:00", "17:00-19:00"];
const SERVICES = ["Instalare sisteme supraveghere", "Instalare smart home", "Instalare automatizare poartă", "Instalare panouri solare", "Mentenanță", "Consultanță"];

export default function Booking() {
    const [date, setDate] = React.useState();
    const [form, setForm] = React.useState({ service_type: SERVICES[0], time_slot: TIME_SLOTS[0], address: "", city: "", phone: "", name: "", email: "", notes: "" });
    const [submitted, setSubmitted] = React.useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (!date) { toast.error("Selectează o dată"); return; }
        try {
            await api.post("/appointments", { ...form, date: date.toISOString().slice(0, 10) });
            toast.success("Programare înregistrată! Te vom contacta pentru confirmare.");
            setSubmitted(true);
        } catch {
            toast.error("Eroare la trimitere");
        }
    };

    if (submitted) {
        return (
            <div className="container-x py-20 text-center" data-testid="booking-success">
                <div className="overline text-primary mb-4">Succes</div>
                <h1 className="font-heading text-4xl uppercase mb-4">Programarea a fost înregistrată!</h1>
                <p className="text-muted-foreground mb-8">Un reprezentant te va contacta în cel mai scurt timp pentru confirmare.</p>
                <button onClick={() => setSubmitted(false)} className="btn-outline">Adaugă altă programare</button>
            </div>
        );
    }

    return (
        <div className="container-x py-10" data-testid="booking-page">
            <div className="mb-10">
                <h1 className="font-heading text-5xl uppercase tracking-tighter font-bold">Programează instalarea</h1>
                <p className="text-muted-foreground mt-3 max-w-2xl">Alege data și intervalul orar potrivit. Confirmarea se va face telefonic.</p>
            </div>
            <form onSubmit={submit} className="grid grid-cols-1 lg:grid-cols-2 gap-10">
                <div>
                    <h2 className="font-heading text-2xl uppercase mb-4">1. Alege data</h2>
                    <div className="border-2 border-foreground p-4 inline-block">
                        <Calendar mode="single" selected={date} onSelect={setDate} disabled={(d) => d < new Date(new Date().setHours(0, 0, 0, 0))} data-testid="booking-calendar" />
                    </div>
                    {date && <div className="mt-4 font-mono text-sm">Data selectată: <strong>{date.toLocaleDateString("ro-RO")}</strong></div>}

                    <h2 className="font-heading text-2xl uppercase mt-6 mb-4">2. Interval orar</h2>
                    <div className="grid grid-cols-2 gap-2">
                        {TIME_SLOTS.map(t => (
                            <button type="button" key={t} onClick={() => setForm(f => ({ ...f, time_slot: t }))}
                                    className={`px-3 py-3 border-2 font-mono text-sm ${form.time_slot === t ? "border-primary bg-primary text-primary-foreground" : "border-foreground"}`}
                                    data-testid={`time-${t}`}>
                                {t}
                            </button>
                        ))}
                    </div>
                </div>
                <div className="space-y-4">
                    <h2 className="font-heading text-2xl uppercase">3. Detalii</h2>
                    <div>
                        <label className="font-mono text-xs uppercase block mb-1">Tip serviciu</label>
                        <select required value={form.service_type} onChange={(e) => setForm(f => ({ ...f, service_type: e.target.value }))} className="w-full px-3 py-3 border-2 border-foreground bg-transparent" data-testid="booking-service">
                            {SERVICES.map(s => <option key={s}>{s}</option>)}
                        </select>
                    </div>
                    <input required placeholder="Nume complet" value={form.name} onChange={(e) => setForm(f => ({ ...f, name: e.target.value }))} className="w-full px-3 py-3 border-2 border-foreground bg-transparent" data-testid="booking-name" />
                    <input required type="email" placeholder="Email" value={form.email} onChange={(e) => setForm(f => ({ ...f, email: e.target.value }))} className="w-full px-3 py-3 border-2 border-foreground bg-transparent" data-testid="booking-email" />
                    <input required placeholder="Telefon" value={form.phone} onChange={(e) => setForm(f => ({ ...f, phone: e.target.value }))} className="w-full px-3 py-3 border-2 border-foreground bg-transparent" data-testid="booking-phone" />
                    <input required placeholder="Adresă completă" value={form.address} onChange={(e) => setForm(f => ({ ...f, address: e.target.value }))} className="w-full px-3 py-3 border-2 border-foreground bg-transparent" data-testid="booking-address" />
                    <input required placeholder="Oraș" value={form.city} onChange={(e) => setForm(f => ({ ...f, city: e.target.value }))} className="w-full px-3 py-3 border-2 border-foreground bg-transparent" data-testid="booking-city" />
                    <textarea placeholder="Observații (opțional)" value={form.notes} onChange={(e) => setForm(f => ({ ...f, notes: e.target.value }))} rows="3" className="w-full px-3 py-3 border-2 border-foreground bg-transparent" />
                    <button type="submit" className="btn-primary w-full" data-testid="booking-submit">Trimite programarea</button>
                </div>
            </form>
        </div>
    );
}
